"use client"

import { Localized } from "@/i18n/client"
import Image from "next/image"
import { createElement, useEffect, useRef, useState } from "react"

import { useSiteMediaUrl } from "@/cms/site-images-client"
import styles from "./brand-logo.module.css"

export function BrandLogo({
  preload = false,
  animated = true,
}: {
  preload?: boolean
  animated?: boolean
}) {
  const mediaUrl = useSiteMediaUrl()
  const mark = useRef<HTMLSpanElement>(null)
  const [ready, setReady] = useState(false)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    const element = mark.current
    if (!animated || !element) return
    const syncReady = () => {
      const phase = element.querySelector("danaro-crest")?.getAttribute("data-phase")
      setReady(Boolean(phase && phase !== "unavailable"))
      if (phase) setFailed(phase === "unavailable")
    }
    element.addEventListener("crest-phase", syncReady)
    syncReady()
    let active = true
    void import("./crest-animation.mjs").then(() => {
      if (active) syncReady()
    }).catch(() => {
      if (active) setFailed(true)
    })
    return () => { active = false; element.removeEventListener("crest-phase", syncReady) }
  }, [animated])

  return <Localized>{(
    <span
      ref={mark}
      className={`danaro-brand-mark ${styles.mark} ${animated ? styles.animated : ""} ${animated && ready ? styles.ready : ""} ${failed ? styles.failed : ""}`}
      aria-hidden="true"
    >
      <Image
        src={mediaUrl("brandLogo")}
        alt=""
        width={1856}
        height={1253}
        preload={preload}
        unoptimized
        className={`danaro-brand-logo ${styles.sizer}`}
      />
      {animated && (
        <>
          <span className={styles.motion}>
            {createElement("danaro-crest", { decorative: "" })}
          </span>
          <noscript>
            <style>{`.${styles.sizer} { visibility: visible !important; }`}</style>
          </noscript>
        </>
      )}
    </span>
  )}</Localized>
}
